export default "__VITE_PUBLIC_ASSET__635c2df4__"